import './input_container.less';

import isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import autobind from 'class-autobind';

const withSmartEmptyError = (ComponentToWrap)=>

  class SmartEmptyWrappedComponent extends Component {

    constructor(props) {
      super(props);
      this.state = {
        hasHadNonEmptyValue: !isEmpty(props.value)
      };
      autobind(this);
    }

    componentWillReceiveProps(nextProps) {
      this.setState(({ hasHadNonEmptyValue })=> ({
        hasHadNonEmptyValue: hasHadNonEmptyValue || !isEmpty(nextProps.value) 
      }));
    }

    render() {
      const { 
        value,
        error,
        ...props
      } = this.props;

      const {
        hasHadNonEmptyValue
      } = this.state;

      var realError = error;
      if (!realError && isEmpty(value) && hasHadNonEmptyValue) {
        realError = 'Cannot be empty';
      }
      return (
        <ComponentToWrap 
          value={value} 
          error={realError} 
          {...props}
        />
      );
    }
  };


export default withSmartEmptyError;

